import React from 'react';
import cn from 'classnames';
import Link from 'next/link';
import AppImage from '@ictlife/core/components/app-image/AppImage';

import MovieImage from '@ictlife/merchant/assets/images/landing_page_2.png';
import ConcertImage from '@ictlife/merchant/assets/images/concert_image.png';
import WeddingImage from '@ictlife/merchant/assets/images/wedding_image.png';
import useRedirectURL from '../../hooks/useRedirectURL';
import styles from './styles/AccountSetupLayout.module.scss';

const AccountSetupLayout = ({ children, type }) => {
  const { loginLink } = useRedirectURL();

  const renderWelcomeMessage = () => {
    switch (type) {
      case 'phone':
        return (
          <div className={styles.illustrationText}>
            <h3 className={styles.illusTitle}>USER REGISTRATION</h3>
            <p>
              Already have an ICTLIFE account?{' '}
              <Link href={loginLink}>Login here</Link>{' '}
            </p>
          </div>
        );

      case 'confirmotp':
        return (
          <div className={styles.illustrationText}>
            <h3 className={styles.illusTitle}>Phone Number Verification</h3>
          </div>
        );

      case 'info':
        return (
          <div className={styles.illustrationText}>
            <h3 className={styles.illusTitle}>Personal account details</h3>
            <p>
              Provide details to allow you to log in and manage your business
            </p>
          </div>
        );

      case 'register':
        return (
          <div className={styles.illustrationText}>
            <h3 className={styles.illusTitle}>Business Details</h3>
            <p>Please give us a few details about your business</p>
          </div>
        );

      case 'claim_details':
        return (
          <div className={styles.illustrationText}>
            <h3 className={styles.illusTitle}>Update Business Name</h3>
            <p>Change to your preferred details</p>
          </div>
        );

      case 'forgotPassword':
        return (
          <div className={styles.illustrationText}>
            <h3 className={styles.illusTitle}>Set Password</h3>
            <p>
              An OTP code will be sent to the phone number registered to your
              account
            </p>
          </div>
        );
      default:
        break;
    }
  };

  const renderPageImage = () => {
    switch (type) {
      case 'phone':
        return (
          <AppImage
            asset={{
              url: WeddingImage,
              description: 'Wedding Event',
            }}
            priority
            className={cn(styles.imgHolder, styles.mechanic)}
            isStaticImport
          />
        );
      case 'confirmotp':
        return (
          <AppImage
            asset={{
              url: ConcertImage,
              description: 'Concert Event',
            }}
            priority
            className={cn(styles.imgHolder, styles.buffet)}
            isStaticImport
          />
        );
      case 'info':
        return (
          <AppImage
            asset={{
              url: MovieImage,
              description: 'Movie Event',
            }}
            priority
            className={cn(styles.imgHolder, styles.tailor)}
            isStaticImport
          />
        );
      case 'register':
        return (
          <AppImage
            asset={{
              url: WeddingImage,
              description: 'Wedding Event',
            }}
            priority
            className={cn(styles.imgHolder, styles.rafting)}
            isStaticImport
          />
        );

      case 'claim':
        return (
          <AppImage
            asset={{
              url: WeddingImage,
              description: 'Wedding Event',
            }}
            priority
            className={cn(styles.imgHolder, styles.rafting)}
            isStaticImport
          />
        );

      default:
        return (
          <AppImage
            asset={{
              url: WeddingImage,
              description: 'Wedding Event',
            }}
            priority
            className={cn(styles.imgHolder, styles.tailor)}
            isStaticImport
          />
        );
    }
  };

  return (
    <div className={styles.authWrapper}>
      <div className={styles.registrationContainer}>
        <div className={styles.formSection}>
          <div className={styles.formWrapper}>
            <div className={styles.logo}>
              {type !== 'phone' && (
                // eslint-disable-next-line @next/next/no-img-element
                <img
                  src="/images/logo/ictlife-logo.svg"
                  alt="ICTLIFE"
                  height="100%"
                  width="auto"
                />
              )}
            </div>
            {process.env.NEXT_PUBLIC_SOURCE_PACKAGE === 'merchant' &&
              type !== 'phone' &&
              type !== 'claimed' &&
              type !== 'claim' &&
              type !== 'claim_details' && (
                <div className={styles.tagLine}>
                  <h1>CREATE MERCHANT ACCOUNT</h1>
                </div>
              )}

            {type === 'claim' ||
              (type === 'claim_details' && (
                <div className={styles.tagLine}>
                  <h1>CLAIM MERCHANT ACCOUNT</h1>
                </div>
              ))}

            {renderWelcomeMessage()}

            {children}
            <div id="resend-code" style={{ display: 'none' }}></div>
          </div>
        </div>
        <div className={styles.illustrationSection}>
          <div className={styles.illustrationImageContainer}>
            {renderPageImage()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSetupLayout;
